<template>
    <div>
        <div class="cc-sub-container topnav">
            <div class="cc-nav-container">
                <div
                    v-for="(item, index) in navList" :key="index"
                    class="cc-nav-item-container"
                    @click="handleNavClick(index, item)"
                >
                    <div
                        class="cc-nav-item"
                        :style="{width: `${item.width}px`}"
                    >
                        <span
                            class="cc-nav-icon"
                            :style="{backgroundImage: `url(${item.icon})`}"
                        ></span>
                        <div>
                            <div class="cc-nav-title">{{ item.title }}</div>
                            <div class="cc-nav-desc">{{ item.desc }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-for="(item, index) in contentList"
            :ref="`content-${index}`"
            :key="index"
            class="cc-sub-container content"
        >
            <div
                class="cc-content-container"
                :class="{'right': index % 2 === 1}"
            >
                <div class="cc-content-text">
                    <div class="cc-content-title">{{ item.title }}</div>
                    <div class="cc-content-desc">{{ item.desc }}</div>
                    <div
                        v-if="item.buttonList
                            && (!optName || checkItemValid(item, {hags, userInfo}))"
                        class="cc-content-button-list"
                    >
                        <div
                            v-for="(buttonItem, index) in item.buttonList"
                            v-show="!optName || checkItemValid(buttonItem, {hags, userInfo})"
                            :key="index + buttonItem.text"
                            class="cc-nav-button active"
                            @click="jumpToContentDetail(buttonItem)"
                        >
                            <font>{{ buttonItem.text }}</font>
                        </div>
                    </div>
                    <div
                        v-else-if="item.routeName
                            && (!optName || checkItemValid(item, {hags, userInfo}))"
                        class="cc-nav-button active"
                        @click="jumpToContentDetail(item)"
                    >开始创作</div>
                    <div
                        v-else
                        class="cc-nav-button disabled"
                    >敬请期待</div>
                </div>
                <div class="cc-video-container">
                    <video
                        :ref="`video-${index}`"
                        controlsList="nodownload"
                        :src="item.video"
                        playsInline="true"
                        webkit-playsinline="true"
                        x-webkit-airplay="true"
                        x5-playsinline="true"
                        x5-video-player-type="h5"
                        x5-video-orientation="portraint"
                        class="cc-video"
                        preload="auto"
                        autoplay
                        muted
                        loop
                    ></video>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {checkItemValid} from '@/common/util';
import {navList, contentList} from '../config/indexV2Old.js';

export default {
    name: 'cc-content',
    inject: ['$toast'],
    data() {
        return {
            checkItemValid,
            navList,
            contentList,
            contentRefs: []
        };
    },
    mounted() {
        const refNames = Object.keys(this.$refs);
        const videos = [];
        const contents = [];
        refNames.forEach(item => {
            if (item.startsWith('video-')) {
                videos.push(this.$refs[item][0]);
            }
            if (item.startsWith('content-')) {
                contents.push(this.$refs[item][0]);
            }
        });
        this.contentRefs = contents;
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.5 // 设置可见性阈值，表示当视频元素至少50%可见时触发回调
        };

        const callback = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const video = entry.target;
                    video.play();
                }
                else {
                    const video = entry.target;
                    video.pause();
                }
            });
        };

        const observer = new IntersectionObserver(callback, options);

        videos.forEach(video => {
            observer.observe(video);
        });
    },
    computed: {
        optName() {
            return this.$store.state.app.userInfo.accountInfo?.optName || '';
        },
        hags() {
            return this.$store.state.app.userInfo.bizHags;
        },
        userInfo() {
            return this.$store.state.app.userInfo;
        }
    },
    methods: {
        handleNavClick(index, item) {
            const offsetTop = this.contentRefs[index].offsetTop;
            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            });
            this.$emit('clickNav', item);
        },
        jumpToContentDetail(item) {
            // 改为抛出事件，如果未登录的话，登录页面要调起登录框
            this.$emit('goDetail', item);
        }
    }
};

</script>

<style lang="less" scoped>
.cc-nav {
    &-container {
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: 1202px;
        height: 128px;
        background: rgba(255, 255, 255, 0.05);
        border: 1px solid #FFFFFF;
        box-shadow: 0px 3.42857px 28.2857px rgba(190, 196, 207, 0.28);
        backdrop-filter: blur(8.14286px);
        border-radius: 118px;
        margin: 0 auto 0;
        padding: 0 9px;
        background: #fff;
    }
    &-item-container {
        // flex: 1;
        display: flex;
        justify-content: center;
        border-right: 1px solid #E2E6F0;

        &:last-child {
            border-right: none;
        }
    }
    &-item {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: transform 300ms ease;
        &:hover {
            transform: translateY(-16px);
        }
    }
    &-icon {
        width: 64px;
        height: 64px;
        background-size: 100% 100%;
        margin-right: 12px;
    }
    &-title {
        font-weight: 500;
        font-size: 24px;
        line-height: 34px;
        color: #282C33;
    }
    &-desc {
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        color: #848B99;
        margin-top: 3px;
    }

}

.cc-sub-container {
    width: 100%;
    // max-width: 1920px;
    margin: 0 auto;
    background-color: #fff;
    &.content {
        background-image: url('../assets/navContentBg1.png');
        background-size: cover;
        overflow: hidden;
    }
    &:nth-child(2) {
        // background-color: transparent;
    }

    &.content:nth-child(2n + 1) {
        background-image: url('../assets/navContentBg2.png');
    }
}
.cc-content {
    &-container {
        width: 1200px;
        margin: 0 auto;
        height: 700px;
        position: relative;
        padding-top: 200px;
        &.right {
            .cc-content-text {
                margin-left: 750px;
            }
            .cc-video-container {
                left: -70px;
            }
        }
    }
    &-text {
        width: 435px;
        min-width: 436px;
        .cc-nav-button {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 160px;
            height: 56px;
            border-radius: 47px;
            border: 1px #3A5BFD solid;
            font-weight: 500;
            font-size: 20px;
            line-height: 56px;
            text-align: center;
            color: #3A5BFD;
            position: relative;

            border: 1px solid transparent;
            background-clip: padding-box, border-box;
            background-origin: padding-box, border-box;
            background-image:
                linear-gradient(to right, #fff, #fff),
                linear-gradient(270.93deg, #3434F4 0.3%, #4C79FF 99.35%);

            margin-right: 20px;
            margin-top: 72px;
            cursor: pointer;
            &.active:hover {
                background-color: #ebf2ff;
                background-image:
                    linear-gradient(to right, #ebf2ff, #ebf2ff),
                    linear-gradient(270.93deg, #3434F4 0.3%, #4C79FF 99.35%);
            }
            &.disabled {
                background-image: none;
                width: 160px;
                cursor: not-allowed;
                color: #A8B0BF;
                border: 1px solid #A8B0BF;
                font {
                    color: #A8B0BF;
                }
            }
            // 文字渐变
            font {
                background: linear-gradient(270.93deg, #3434F4 0.3%, #4C79FF 99.35%);
                color: transparent;
                -webkit-background-clip: text;
                margin: 0 19px;
            }
        }
    }
    &-text-right {
        // padding: 48px 0 0 115px;
    }
    &-title {
        font-weight: 600;
        font-size: 60px;
        line-height: 84px;
        color: #0A0B0D;
    }
    &-desc {
        margin-top: 16px;
        font-weight: 400;
        font-size: 20px;
        line-height: 32px;
        color: #282C33;
    }

    &-button-list {
        display: flex;
    }

}
.cc-video-container {
    width: 785px;
    height: 557px;
    background: url('../assets/videoBg.png') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    right: -75px;
    top: 78px;
    .cc-video {
        width: 645px;
        height: 420px;
        border-radius: 36px;
        position: absolute;
        top: 64px;
        left: 70px;
    }
}
</style>